import React, { PureComponent } from 'react'
import ReactMarkdown from 'react-markdown'

import RenderProduct from './RenderProduct'

export default class RenderCategory extends PureComponent {
  render() {
    let products = this.props.products
    let category = this.props.category

    if(category.fields) {
      return(
        <div className="subcategory">
          {category.fields.title && <h3>{category.fields.title}</h3>}
          {category.fields.children && category.fields.children.map((child) => {
            let product = products.find((p) => {
              return p.sys.id === child.sys.id
            })
            return(
              <RenderProduct product={product} key={product.fields.title} />
            )
          })}
          {category.fields.description && <ReactMarkdown source={category.fields.description} softBreak="br" />}
        </div>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/RenderCategory.js